module.exports = __webpack_public_path__ + "static/media/logout.38e28f9c.svg";